// @ts-ignore-file
import React, { Component } from "react";

//import Jodit from "jodit";
import _, { isNil } from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepIcon from "@material-ui/core/StepIcon";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import StepContent from "@material-ui/core/StepContent";
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import { onlyAllowNumbers, validateGoalLevels } from "../../../utils/index";
import { getGoalList,showMsg } from "../actions/goalManagementActions";
import moment from "moment";
import cx from 'classnames';
import { GoalLevel } from "../types/GoalLevel";
import StepConnector from "@material-ui/core/StepConnector";
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";

import {
  Theme,
  createStyles,
  withStyles,
  WithStyles,
  Card,
  CardContent,
  Grid,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  TextField,
  FormControl,
  Link,
  InputAdornment,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { MyPATTextField, MyPATSelect, MyPATDropdown } from "../../common";

import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@material-ui/icons/Cancel";
import goalManagementService from "../services/goalManagementService";
import { GOAL_ACTION_TYPE_CONST } from "../container/GoalManagementContainer";
import OutLineDiv from "./OutLineDiv";
import CareerTypeField, { CareerType } from "./CareerTypeField";
import "jodit/build/jodit.min.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import TargetYear from "./TargetYear";
import MyPATCalendar from "../../common/MyPATCalendar";
import MyPATUploader, { Attachment } from "../../common/MyPATUploader";
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem, PreviewItem } from "../../common/MyPATUploadPreview";
import { parse } from "date-fns";
// @ts-ignore
const { Jodit } = require("jodit");



const styles = (theme: Theme) =>
  createStyles({
    error: {
      color: "hsl(347deg 79% 54%) !important",
      fontSize: 16,
    },
    height81: {
      height: 80,
    },
    height80: {
      height: 40,
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'center',
      lineHeight: 40,
    },
    activeStep: {
      borderLeft: "2px solid #1d7dea",
    },
    marginLeft35: {
      margin: "-36px",
    },
    paddingRight35: {
      paddingRight: 35,
    },
    disableOpacity: {
      opacity: 0.4,
      cursor: "no-drop",
    },
    disableState: {
      cursor: "no-drop",
    },
    margin0: {
      margin: "0px",
    },
    lightGrey: {
      backgroundColor: "hsl(0deg 0% 98%)",
    },
    grey: {
      color: "hsl(0deg 0% 65%)",
    },
    margin2x: {
      margin: "24px 0px 0px !important",
    },
    relativeWidth86: {
      width: "86%",
    },

    joditEditorBlock: {
      "&>:first-child": {
        minHeight: "40px !important",
        width: 613,
        "& .jodit-workplace": {
          minHeight: "40px !important",
          width: 612,
        },
        "& .jodit-toolbar-button__button": {
          "&:active": {
            "&:not([disabled])": {
              backgroundColor: "hsl(0deg 0% 74%)",
            },
          },
        },
        "& .jodit-wysiwyg": {
          minHeight: "40px !important",
          fontSize: 16,
          color: "hsl(0deg 0% 40%)",
        },
        "& .jodit-placeholder": {
          fontSize: "16px !important",
        },
      },
    },
    root: {
      "&$checked": {
        color: "#1D7DEA !important",
      },
      "& label.MuiFormLabel-root": {
        fontSize: "1rem",
        color: "#33333",
      },
      "& p, a": {
        color: "#33333",
        fontSize: "1rem",
      },
    },

    blueColor: {
      color: "#1D7DEA",
    },

    btnCreateGoal: {
      marginTop: 18,
    },

    cardContainer: {
      borderRadius: 4,
      width: "50%",
    },

    cardContentRoot: {
      padding: 0,
      "&:last-child": {
        padding: "20px",
      },
      backgroundColor: "#F7F7F7",
      background: "#F7F7F7",
    },

    cardContentBox: {
      // background: "#FFFFFF",
      background: "#fbfbfb",
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.287534)",
      borderRadius: 4,
      padding: 20,
      maxHeight: 470,
      height: "auto",
      overflowY: "auto",
    },

    chip: {
      margin: theme.spacing.unit,
    },
    dateInput: {
      "& ::placeholder": {
        color: "hsl(0deg 0% 65%) !important",
        fontWeight: "normal",
        fontSize: 14,
        opacity: 1,
      },
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
      padding: "0px 5px",
    },

    classesDropdown: {
      boxSizing: "border-box",
      borderRadius: 4,
      "& *:before": {
        border: "none !important",
      },
      width: "90%",
      minHeight: 36,
    },

    cancelIconStyle: {
      cursor: "pointer",
      "& svg": {
        color: "#848484",
        marginLeft: 12,
        marginTop: 8,
        position: "absolute",
      },
    },

    addMoreStyle: {
      cursor: "pointer",
      color:"#1D7DEA",
      textDecoration: "underline",
      fontSize:"0.875rem",
      "&:hover": {
        textDecoration: "underline",
        backgroundColor:"transparent"
    },
    
    },

    classesList: {
      "& *ul": {
        height: 200,
      },
      "& svg": {
        color: "#848484",
        marginLeft: 12,
      },
    },

    chipClasses: {
      margin: "3px 5px 3px 3px",
      height: 28,
      background: "#EBEBEB",
      borderRadius: 36,
      color: "#666666",
    },

    dateIcon: {
      position: "absolute",
      marginLeft: -24,
      marginTop: 8,
      zIndex: 999,
      opacity: 1,
    },

    examDate: {
      background: "#fff",
      "& *:before": {
        border: "none !important",
      },
      "& fieldset": {
        borderColor: "#dfdfdf !important",
      },
      "& input": {
        zIndex: 1,
        background: "hsl(0deg 0% 0% / 0%)",
        cursor: "pointer",
        "&::-moz-placeholder": {
          /* Firefox 19+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-ms-input-placeholder": {
          /* IE 10+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-moz-placeholder": {
          /* Firefox 18- */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&::placeholder": {
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
      },
      "& .customMargin": {
        margin: 8,
      },
      "& input::-webkit-inner-spin-button,& input::-webkit-calendar-picker-indicator": {
        opacity: 0,
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        cursor: "pointer",
      },
      "& input::-moz-inner-spin-button,& input::-moz-calendar-picker-indicator": {
        opacity: 0,
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        cursor: "pointer",
      },
      "&::after": {
        content: '" "',
        backgroundImage: "url(/assets/svg/calendarIcon.svg)",
        backgroundRepeat: "none",
        position: "absolute",
        right: 0,
      },
    },
    examDateDisabled: {
      background: "#fff",
      "& *:before": {
        border: "none !important",
      },
      "& fieldset": {
        borderColor: "#dfdfdf !important",
      },
      "& input": {
        zIndex: 1,
        background: "hsl(0deg 0% 0% / 0%)",
        cursor: "no-drop",
        "&::-moz-placeholder": {
          /* Firefox 19+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-ms-input-placeholder": {
          /* IE 10+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-moz-placeholder": {
          /* Firefox 18- */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&::placeholder": {
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
      },
      "& .customMargin": {
        margin: 8,
      },
      "& input::-webkit-inner-spin-button,& input::-webkit-calendar-picker-indicator": {
        opacity: 0,
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        cursor: "no-drop",
      },
      "& input::-moz-inner-spin-button,& input::-moz-calendar-picker-indicator": {
        opacity: 0,
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        cursor: "no-drop",
      },
      "&::after": {
        content: '" "',
        backgroundImage: "url(/assets/svg/calendarIcon.svg)",
        backgroundRepeat: "none",
        position: "absolute",
        right: 0,
      },
    },

    examDateRange: {
      display: "flex",
      width: "45%",
      "& > span": {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 16,
        color: "#333333",
        margin: '10px 10px 10px 0',
      },
      // "& svg": {
      //   color: "#848484",
      //   marginLeft: 12,
      // },
    },

    textColor: {
      color: "#333333",
    },

    fontSizeLG: {
      fontSize: "1.75rem",
    },

    fontSizeMD: {
      fontSize: "1rem",
    },
    fontSizeSM: {
      fontSize: "0.7rem",
    },

    fontWeight500: {
      fontWeight: 500,
    },
    "& svg": {
      color: "#848484",
      marginLeft: 12,
    },

    greyText: {
      color: "#999",
    },

    careerTypeScrollbar: {
      maxHeight: 250,
    },
    paddingRight: {
      paddingRight: "30px !important",
    },

    modal: {
      display: "flex",
      padding: 0,
      zIndex: 1,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 4,
      margin: "0px 0px 12px 80px",
    },

    mt1x: {
      marginTop: 8,
    },

    modalHeader: {
      height: 66,
      boxShadow: "7px 0px 1px rgb(0 0 0 / 12%)",
      backgroundColor: "#fff",
    },

    mb1x: {
      marginBottom: theme.spacing.unit * 2,
    },

    paper: {
      width: "calc(100% - 0px)",
      height: "100%",
      // backgroundColor: "#fff",
      // boxShadow: theme.shadows[5],
      padding: "20, 40, 30",
      borderRadius: 4,
      outline: "#fff",
      marginLeft: "auto",
    },

    perfectScrollbar: {
      maxHeight: "100vh",
      borderRadius: 4,
      "& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y": {
        opacity: 1,
      },
      paddingBottom: "140px",
      width: "100%",
      paddingRight: "40%",
    },
    paddingSM: {
      padding: "0px 10px",
    },

    textCenter: {
      textAlign: "center",
    },

    widthLG: {
      width: "240px",
    },

    widthXL: {
      width: "80%",
    },
    title: {
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: "32px",
      textAlign: "left",
    },

    labelText: {
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "20px",
      color: "hsl(0deg 0% 20%)",
      minHeight: 25,
    },

    stepLabelTitle: {
      "& span:nth-of-type(2)": {
        "& span": {
          fontWeight: 700,
          color: "#333",
          textTransform: "uppercase",
          paddingLeft: "13px",
          fontSize: 18,
        },
      },
    },
    labelCustomIcon: {
      width: "54px",
    },
    formTitle: {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "calc(100% - 80px)",
      display: "block",
      bottom: 0,
      marginRight: "auto",
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      paddingBottom: "14px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    },
    fullMinHeight: {
      height: "calc(100vh - 132px)",
      overflow: "auto",
    },

    stepContentStyle: {
      marginLeft: "25px",
      paddingLeft: "35px",
      marginBottom: -24,
    },
    closeContainer: {
      position: "relative",
      margin: "16px 0px",
      width: "100%",
    },
    marginSM: {
      margin: "20px 0px 0px",
    },
    classesCloseButton: {
      marginTop: 34,
      left: "50%",
      color: "hsl(0deg 0% 100%)",
      padding: 0,
      position: "absolute",
      backgroundColor: "hsl(0deg 0% 52%)",
      "&:hover": {
        backgroundColor: "#848484",
      },
    },
    dateCloseButton: {
      top: 10,
      right: -10,
      color: "hsl(0deg 0% 100%)",
      padding: 0,
      fontSize: "1.3rem",
      position: "relative",
      height: 18,
      backgroundColor: "hsl(0deg 0% 52%)",
      width: 18,
      "&:hover": {
        backgroundColor: "#848484",
      },
    },
    closeButton: {
      top: 36,
      right: "-35px",
      position: "absolute",
      backgroundColor: "#848484",
      padding: "2px",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#848484",
      },
    },
    connector: {
      marginLeft: "13px",
    },
    iconStyle: {
      "& img": {
      },
    },
    paddingLeft: {
      paddingLeft: "13px",
      paddingRight: "14px",
    },
    spacingFix: {
      paddingLeft: "33px",
    },
    fileLabel: {
      cursor: "pointer",
      padding: "0px 6px 0px 0px",
    },
    inputFile: {
      display: "none",
    },
    courseImageUploadBtn: {
      backgroundColor: "#1D7DEA",
      color: "white",
      padding: "0.5rem",
      borderRadius: "0.3rem",
      cursor: "pointer",
      // marginTop: '1rem',
      display: "block",
    },
    greyBorder: {
      border: "1.5px solid #999",
    },
    courseImageContainer: {
      borderRadius: "5px",
      // margin: '1rem 0',
      backgroundColor: "#fff",
      padding: "10px 15px",
      // maxWidth: "96%",
      margin: "10px auto 20px",
      marginBottom: 30,
    },
    imgContainer: {
      position: "relative",
      marginRight: 20,
      padding: 4,
      backgroundColor: "#fafafa",
      borderRadius: 4,
      width: 70,
      height: 70,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      '& img':{
        width: 55,
      }
    },
    editIconContainer: {
      position: "absolute",
      bottom: "1px",
      right: "-8px",
      borderRadius: "50%",
      padding: "3px",
      fontSize: "1rem",
      width: 20,
      height: 20,
      backgroundColor: '#fff',
      '& svg':{
        width: 10,
      }
    },
    doneIconContainer: {
      padding: "3px 10px 6px 10px",
      fontSize: "1.3rem",
      borderRadius: "50%",
      border: "1px solid green",
      color: "green",
      marginRight: "15px",
      width: 40,
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      padding: "4px 20px",
      "& svg": {
        verticalAlign: "bottom",
      },
    },
    attachFileContainer: {
      background: "#FFFFFF",
      border: "1px solid #DFDFDF",
      boxSizing: "border-box",
      borderRadius: 4,
      width: "100%",
      "& .paddingMD": {
        padding: "6px 20px 4px",
      },
      "& .buttonSubLabel": {
        padding: "13px 0",
        "& p": {
          color: "#666",
        },
      },
      "& .attachmentIcon": {
        display: "inline-block",
        verticalAlign: "middle",
        paddingTop: 8,
      },
      "& .padding30": {
        padding: "12px 0px 30px",
      },
      "& .uploadPreviewBox": {
        minHeight: 16,
        padding: "16px 0px 0px",
      },
      "& .heading": {
        padding: "16px 20px",
        borderBottom: "solid 1px rgb(223 223 223)",
        "& p": {
          fontSize: 18,
          fontWeight: 400,
        },
      },
    },
    joditEditior: {
      "&>:first-child": {
        minHeight: "40px !important",
        "& .jodit-workplace": {
          minHeight: "40px !important",
          maxHeight: "400px !important",
        },
        "& .jodit-wysiwyg": {
          minHeight: "40px !important",
        },
      },
    },
    // swotContainer:{
    //   '&>div:nth-of-type(1)':{
    //     '&>div':{
    //       padding: '5px 10px',
    //     }
    //   }
    // },

    swotContainer:{
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      '&>div:nth-of-type(1)':{
        width: '100%',
        '& input':{
          // padding: 0,
          '&[type=number]': {
            '-moz-appearance': 'textfield',
          },
          '&-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
          '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
        },
        '&>div:nth-of-type(1)':{
          width: '60px',
          marginLeft: 10,
          marginRight: 10,
          '&>div:nth-of-type(1)':{
            display: 'none',
          }
        },
      }
    },
    calenderContainer:{
      width: '100%',
      '&>div:nth-of-type(1)':{
        width: '100%',
        '&>div:nth-of-type(1)':{
          marginBottom: 0,
          '&>div:nth-of-type(1)':{
            padding: '6px 0',
            '& input':{
              paddingRight: 0,
              fontSize: 14,
            },
            '&>div:nth-of-type(1)':{
              '& > button':{
                padding: '5px 5px 5px 0',
              }
            }
          }
        }
      },

    },
    halfBorder:{
      position: 'relative',
      zIndex: 1,
      '&:before':{
        content: " '' ",
        position: 'absolute',
        width: '100%',
        height: '2px',
        bottom: 0,
        zIndex: -1,
        top: '50%',
        background: 'linear-gradient(45deg, #333, transparent)',
      },
      '& p':{
        padding: '10px 10px 10px 0',
        background: '#fafafa',
        display: 'inline-block',
        fontSize: 18,
        fontWeight: 600,
      }
    },
    dropDownCont:{
      '& span':{
        '& img':{
          marginLeft: 'initial',
        }
      }
    },
    padding0:{
      padding: 0,
    },
    spaceMargin:{
      margin: '10px !important',
    },
    isDisabled: {
      opacity: 0.4
    },
    popupContent: {
      width: '100%',
      textAlign: 'center',
      marginTop: 5,
      marginBottom: 5 
    }
  });

interface AddGoalDialogProps extends WithStyles<typeof styles> {
  isDialogOpen: boolean;
  dialogCloseHandler: () => void;
  dialogData: any;
  actionType: string;
  getGoalList: () => void;
  showMsg:Function,
  id: string;
  history: any;
  eventsName: any;
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  goalId:"",
  showLoader: () => void,
  hideLoader: () => void;
}

const INITIAL_GOAL_LEVEL_STATE = [{ name: "", scale: 0 }];
const BUSINESS_TYPES = [{ label: 'B2C', value: 'b2c' }, { label: 'Schools', value: 'school' }, { label: 'FIITJEE', value: 'fiitjee' }]

interface GoalLevelErrors {
  name: string[];
  scale: string[];
}
interface GaolCategory{
  _id:string;
  displayName:string
}

interface swotCategory{
  strength:any;
  weakness:any,
  opportunity:any,
  threat:any
}
interface AddGoalDialogState {
  formData: {
    name?: string;
    targetYear: any;
    description: string;
    shortCode: string;
    endDate: any;
    examDates: any[];
    eligibleClasses: any[];
    goalLevels: GoalLevel[];
    selectedCareerIds: string[];
    removedCareerIds: string[];
    myPatGoalId:any,
    businessTypes: { name: string }[],
    courseImage?: Attachment;
    swotVisibility:swotCategory;
    pastClasses: {id: string; name: string}[];
    baseVersionYear?: string | null,
  };
  classList: any[];
  errForm: {
    name: string;
    goalLevels: GoalLevelErrors[];
    careerType: string;
    shortCode:string;
  };
  isCheckedData: boolean;
  age: string[];
  setAge: string[];
  open: boolean;
  setOpen: boolean;
  isBasicFocus: boolean;
  isClassesFocus: boolean;
  isGoalFocus: boolean;
  setChipData: [
    "Select Class",
    "Class 1",
    "Class 2",
    "Class 3",
    "Class 4",
    "Class 5",
    "Class 6",
    "Class 7",
    "Class 8"
  ];
  sessionClassYearList:any[];
  goalCategory: GaolCategory[];
  selectCategory:string,
  endExpriyDate:Date,
  selectedGoalScale:boolean,
  onTargetYearChange:boolean,
  minExpiryDate:Date,
 }

interface ApplicableClasses {
  key: number;
  label: string;
}

const ROMAN_CONSTANT: any = {
  "1st": "I",
  "2nd": "II",
  "3rd": "III",
  "4th": "IV",
  "5th": "V",
  "6th": "VI",
  "7th": "VII",
  "8th": "VIII",
  "9th": "IX",
  "10th": "X",
  "11th": "XI",
  "12th": "XII",
  "12th Pass": "XII Pass",
};

const ROMAN_CONSTANT_REVERSE: any = {
  I: "1st",
  II: "2nd",
  III: "3rd",
  IV: "4th",
  V: "5th",
  VI: "6th",
  VII: "7th",
  VIII: "8th",
  IX: "9th",
  X: "10th",
  XI: "11th",
  XII: "12th",
  "XII Pass": "12th Pass",
};

const INITIAL_ERROR_FORM_STATE = {
  name: "",
  goalLevels: [],
  careerType: "",
  shortCode:"",
};

const ALLOWED_COURSE_IMAGE_TYPES = ['png', 'svg+xml', 'jpg', 'jpeg'];
const MAX_COURSE_IMAGE_DIMENSIONS = { width: 800, height: 400 };

class AddGoalDialog extends Component<AddGoalDialogProps, AddGoalDialogState> {
  applicableClassesList: ApplicableClasses[] = [
    { key: 1, label: "Class 1" },
    { key: 2, label: "Class 2" },
    { key: 3, label: "Class 3" },
    { key: 4, label: "Class 4" },
    { key: 5, label: "Class 5" },
    { key: 6, label: "Class 6" },
    { key: 7, label: "Class 7" },
    { key: 8, label: "Class 8" },
  ];
  jodit: any = {};
  handleJoditOnChange: (value: string) => void;
  
  constructor(props: AddGoalDialogProps) {
    super(props);
    const { dialogData } = props;
    this.state = {
      formData: {
        name: "",
        targetYear: '',
        description: "",
        shortCode: "",
        selectedCareerIds: [],
        removedCareerIds: [],
        endDate: null,
        examDates: [
          {
            startDate: null,
            endDate: null,
          },
        ],
        swotVisibility:{
          strength:'',
          weakness:'',
          opportunity: '',
          threat: '',
        },
        eligibleClasses: [
          {
            sessionStartTime: new Date().getFullYear(),
            sessionEndTime: new Date().getFullYear() + 1,
            sessionInterval: "Yearly",
            class: {
              id: "",
              name: "",
            },
            error:""
          },
        ],
        myPatGoalId:'',
        goalLevels: INITIAL_GOAL_LEVEL_STATE,
        courseImage: '',
        pastClasses: [],
        businessTypes: [],
        baseVersionYear: "",
      },
      classList: [],
      errForm: INITIAL_ERROR_FORM_STATE,
      isCheckedData: false, 
      isBasicFocus: false,
      isClassesFocus: false,
      isGoalFocus: false,
      age: [],
      setAge: [],
      setOpen: false,
      open: false,
      setChipData: this.props.dialogData.className,
      goalCategory: [],
      selectCategory:'',
      endExpriyDate:new Date(),
      selectedGoalScale:false,
      onTargetYearChange:false,
      minExpiryDate:new Date(),
      sessionClassYearList:[]
   
    };
    this.jodit = {};
    this.handleJoditOnChange = _.debounce(this.onJoditValueChange, 400);
    this.createGoalClickHandler = this.createGoalClickHandler.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTentativeDate = this.handleTentativeDate.bind(this);
   this.handleTargetChange = this.handleTargetChange.bind(this);
  }
 
  componentDidMount() {
    const { dialogData } = this.props;
    
    const name =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? ""
        : this.props.dialogData["courseType"]["name"];
    const description =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? ""
        : this.props.dialogData["description"];
    const shortCode =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? ""
        : this.props.dialogData["courseType"]["id"]["shortCode"];
    const targetYear =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION 
     // || this.props.actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
        ? this.state.formData.targetYear = new Date().getFullYear()
        : this.props.dialogData["targetYear"];
    const endDate =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? null
        : moment(this.props.dialogData["endDate"]).format("YYYY-MM-DD");
    const examDates =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? [
            {
              startDate: null,
              endDate: null,
            },
          ]
        : !!(this.props.dialogData["examDates"] && this.props.dialogData["examDates"].length)
        ? this.props.dialogData["examDates"].map(
            (examObj: any, index: number) => ({
              startDate: this.checkNullOrUndefinedDate(
                this.props.dialogData["examDates"][index]["startDate"]
              ),
              endDate: this.checkNullOrUndefinedDate(
                this.props.dialogData["examDates"][index]["endDate"]
              ),
            })
          )
        : [
            {
              startDate: null,
              endDate: null,
            },
          ];
          const swotVisibilityValue = this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
    this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION || _.isUndefined(this.props.dialogData.swotVisibility)
    ?{
      strength: '',
      weakness: '',
      opportunity: '',
      threat: ''
    }:this.props.dialogData.swotVisibility
  
    const eligibleClasses =  this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION
        ? [
            {
              sessionStartTime: new Date().getFullYear().toString(),
              sessionEndTime: (new Date().getFullYear() + 1).toString(),
              sessionInterval: "Yearly",
              class: {
                id: "",
                name: "",
              },
            },
          ]
        : !!this.props.dialogData["eligibility"].length
        ? this.props.dialogData["eligibility"].map((eligibilityObj: any) => {
            return {
              ...eligibilityObj,
              sessionStartTime: eligibilityObj.sessionStartTime.toString(),
              sessionEndTime: eligibilityObj.sessionEndTime.toString(),
              class: {
                ...eligibilityObj.class,
                name: eligibilityObj["class"]["name"] === "XII +" ? ROMAN_CONSTANT_REVERSE["XII Pass"] : ROMAN_CONSTANT_REVERSE[eligibilityObj["class"]["name"]],
              },
            };
          })
        : [
            {
              sessionStartTime: new Date().getFullYear().toString(),
              sessionEndTime: (new Date().getFullYear() + 1).toString(),
              sessionInterval: "Yearly",
              class: {
                id: "",
                name: "",
              },
            },
          ];
          const isAddingNewGoal =this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL
          const goalPayload = isAddingNewGoal?"":this.props.goalId
           goalManagementService.getGoalCategory(goalPayload)
             .then((category:GaolCategory[]) => {
               this.setState((prevState:AddGoalDialogState)=>{
                 return {...prevState,
                goalCategory:category,
              formData:{...prevState.formData,myPatGoalId:isAddingNewGoal?"":_.get(category,"[0]_id","")}}
               })
             });
      this.setState({
      formData: {
        name,
        targetYear: this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ? this.props.dialogData.targetYear:
        this.props.actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ? '' : this.props.dialogData.targetYear,
        description,
        shortCode,
        endDate,
        examDates,
        eligibleClasses,
        goalLevels: INITIAL_GOAL_LEVEL_STATE,
        selectedCareerIds: [],
        removedCareerIds: [],
        swotVisibility:swotVisibilityValue,
         myPatGoalId:"",
         courseImage: _.get(dialogData, 'courseType.courseImage', ''),
        pastClasses: _.get(dialogData, 'courseType.pastClasses', []),
        businessTypes: _.get(dialogData, 'courseType.businessTypes', []),
         //:this.props.dialogData.latestGoalId,
        baseVersionYear: "",
      },
    });
    goalManagementService.fetchMasterClass().then((resObj: any) => {
      this.setState({
        classList: resObj,
      });
    });
   const areGoalLevelsToBeFetched =
      this.props.actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL;
    if (areGoalLevelsToBeFetched) {
      const {
        courseType: {
          id: { _id: courseTypeId },
        },
      } = this.props.dialogData;
      // fetch goal levels
      goalManagementService
        .getGoalLevels({ courseTypeId })
        .then((resObj: any) => {
          const { hasGoalLevels, goalLevels } = resObj;
          if (hasGoalLevels) {
            this.setState((prevState) => ({
              ...prevState,
              formData: { ...prevState.formData, goalLevels },
            }));
          }
        });
    }
    this.props.setLoggedInUser();
  setTimeout(() => {
      this.configureJodit();
    }, 10);
   // const courseTypeIdAvailable = _.get(this.props.dialogData.courseType.id._id,"")
  }

  onJoditValueChange = (value: string) => {
    const {formData } = this.state
   formData.description=value
  this.setState({ formData })
  };
  configureJodit = () => {
    const editorElem = document.getElementById("editor");
    if (!editorElem) {
      return;
    }
    this.jodit = new Jodit(editorElem, {
      buttons: joditButtons,
      buttonsMD: joditButtons,
      buttonsSM: joditButtons,
      buttonsXS: joditButtons,
      events: {
        change: this.handleJoditOnChange,
      },
      askBeforePasteHTML: false,
      enter: "div",
      tabIndex:0,
      placeholder: 'Enter Description of the goal'
    });

    this.jodit.value = this.state.formData.description;
  };
  resetForm = () => {
    const { dialogData } = this.props;
    const {goalCategory } = this.state;
    const formData = {
      name: "",
      selectedCareerIds: [],
      removedCareerIds: [],
      targetYear:dialogData.targetYear,
      description: "",
      shortCode: "",
      endDate: null,
      examDates: [
        {
          startDate: '',
          endDate: "",
        },
      ],
      eligibleClasses: [
        {
          sessionStartTime: new Date().getFullYear().toString(),
          sessionEndTime: (new Date().getFullYear() + 1).toString(),
          sessionInterval: "Yearly",
          class: {
            id: "",
            name: "",
          },
        },
      ],
      myPatGoalId:_.get(goalCategory,"_id",""),
      goalLevels: INITIAL_GOAL_LEVEL_STATE,
      courseImage: '',
      pastClasses: [],
      businessTypes: [],
      swotVisibility:{
        strength: '',
        weakness: '',
        opportunity: '',
        threat: '',
      },
      baseVersionYear: ""
    };
    return this.setState({ formData });
  };

  checkNullOrUndefinedDate(dateValue: any) {
    if (dateValue === null) {
      return "";
    } else if (dateValue === undefined) {
      return "";
    } else if (dateValue === "") {
      return "";
    } else {
      return moment(dateValue).format("YYYY-MM-DD");
    }
  }

  preventShortCodeMaxLength = (evt: any) => {
    const { value } = evt.target;
    if (value.length > 5) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  };

  capitalize = (s: any) => {
    if (typeof s !== "string") return s;
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  handleExipryChange=(event:any)=>{
   const { formData,onTargetYearChange } = this.state;
    formData.endDate = event;
    this.setState({formData})
  
  
//this.setState({formData})
  }
  
  handleTargetChange =(data:string)=>{
    let { formData,minExpiryDate,onTargetYearChange } = this.state;
    if(formData.targetYear === data){
      return
    }
 
  if(formData.targetYear != data){
    formData.endDate="";
    minExpiryDate=new Date()
  // onTargetYearChange= true
    formData.targetYear = data;
  }
  formData.eligibleClasses = formData.eligibleClasses.map(
    (eligibleClassObj: any, index: number) => ({
      ...eligibleClassObj,
      sessionStartTime: ( parseInt(data)- 1),
      sessionEndTime: data,
    })
  )
//  formData.examDates.map((examobj:any,index:number)=>{
//   examobj[index]["startDate"] = ""
//   examobj[index]["endDate"] = ""
//   })
this.setState({formData,minExpiryDate})
  }

  handleCategoryChange =(event:any)=>{
      const { formData } = this.state;
    formData.myPatGoalId = event;
  this.setState({formData})
  }

  handleInputChange = (evt: any) => {
    let { formData,goalCategory }: any = this.state;
    const { name, value } = evt.target;
    if (name === "shortCode") {
      formData[name] = value;
    }
      else {
      let capitalizeValue = this.capitalize(value);
      formData[name] = capitalizeValue;
    }
    return this.setState({ formData });
  };

  handleSwotChange=(evt:any)=>{
    let { formData } = this.state;
  
   if(parseInt(evt.target.value) <0 || parseInt(evt.target.value)>365
    || /[^a-zA-Z0-9]+/.test(evt.target.value) || /[a-zA-Z]/g.test(evt.target.value)
    ){
      return ''
    }
    if(formData.swotVisibility){
    if(evt.target.name ==="Strength"){
      formData.swotVisibility.strength = evt.target.value
    }else if(evt.target.name ==="Opportunity"){
      formData.swotVisibility.opportunity = evt.target.value
    }else if(evt.target.name ==="Weekness"){
      formData.swotVisibility.weakness = evt.target.value
    }else if(evt.target.name ==="Threats"){
      formData.swotVisibility.threat = evt.target.value
    }
    this.setState({formData})
  }else{
  
      const swotObject:any={
        strength:'',
        opportunity:'',
        weakness:'',
        threat:''
      }
      if(evt.target.name ==="Strength"){
        if(evt.target.value.length==0){
          swotObject.strength=''
        }else{
        swotObject.strength = evt.target.value
        }
      }else if(evt.target.name ==="Opportunity"){
        swotObject.opportunity = evt.target.value
      }else if(evt.target.name ==="Weekness"){
        swotObject.weakness = evt.target.value
      }else if(evt.target.name ==="Threats"){
        swotObject.threat = evt.target.value
      }
      formData.swotVisibility = swotObject;
      this.setState({formData})
    }
  

  }

  handleScaleValue=(e:any)=>{
    const index = parseInt(e.target.name.split("-")[1]);
    const value: string = e.target.value;
    this.state.formData.goalLevels.map((data:any,changeIndex:number)=>{
       if(index === changeIndex){
           if(value < data.scale){
          return true
           }
        }
    })
  }
  getParsedInt(num: string | number) {
    return parseInt(num.toString()) || 0;
  }
  handleGoalLevelChange = (fieldType: string) => (e: any) => {
    const {actionType} = this.props;
    const index = parseInt(e.target.name.split("-")[1]);
    const value: string = e.target.value;
    
    function getFinalValue(
      type: string,
      value: string,
      prevValue: string | number
    ) {
      if (type === "scale") {
        let finalVal = parseInt(value);
        if (finalVal < 1) {
          return 1;
        } else if (finalVal > 100) {
          return prevValue;
        }
        return value ? parseInt(value) : value;
      }
      return value;
    }

    this.setState((prevState) => {
      const newGoalLevels = [...prevState.formData.goalLevels];
      let newGoalLevelErrors = prevState.errForm.goalLevels;
      if (index < newGoalLevels.length) {
        const newGoalLevel = { ...newGoalLevels[index] };
        const nextGoalLevel = { ...newGoalLevels[index+1]}
        const previousGoalLevel = { ...newGoalLevels[index-1]}
        const prevValue = newGoalLevel[fieldType];
        newGoalLevel[fieldType] = getFinalValue(fieldType, value, prevValue); // get actual value to store
      if(actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL){
        if(!_.isEmpty(previousGoalLevel) && !_.isEmpty(nextGoalLevel)){
      if(this.getParsedInt(newGoalLevel.scale) <= this.getParsedInt(previousGoalLevel.scale) && this.getParsedInt(newGoalLevel.scale) >= this.getParsedInt(nextGoalLevel.scale)){
        this.setState({selectedGoalScale:false})
        }else{
          this.setState({selectedGoalScale:true})
        }
       }
       else if(!_.isEmpty(previousGoalLevel) && _.isEmpty(nextGoalLevel)){
        if(this.getParsedInt(newGoalLevel.scale) <= this.getParsedInt(previousGoalLevel.scale)){
        this.setState({selectedGoalScale:false})
        }else{
          this.setState({selectedGoalScale:true})
        }
       }
       else if(_.isEmpty(previousGoalLevel) && !_.isEmpty(nextGoalLevel) ){
         if(this.getParsedInt(newGoalLevel.scale)>= this.getParsedInt(nextGoalLevel.scale)){
         this.setState({selectedGoalScale:false})
         }else{
           this.setState({selectedGoalScale:true})
         }
       }
      }
        newGoalLevels[index] = newGoalLevel;
        if (!!newGoalLevelErrors[index]) {
          // Remove error of the field if user started typing in that field
          newGoalLevelErrors = [...newGoalLevelErrors];
          newGoalLevelErrors[index] = {
            ...newGoalLevelErrors[index],
            [fieldType]: "",
          };
        }
      }
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          goalLevels: newGoalLevels,
        },
        errForm: {
          ...prevState.errForm,
          goalLevels: newGoalLevelErrors,
        },
      };
    });
  };

  handleNumberOfGoalLevels = (action: "add" | "remove", index?: number) => {
    this.setState((prevState) => {
      let newGoalLevels = [...prevState.formData.goalLevels];
      let newGoalLevelErrors = [...prevState.errForm.goalLevels];
      if (action === "add") {
        newGoalLevels = newGoalLevels.concat(INITIAL_GOAL_LEVEL_STATE);
      } else {
        newGoalLevels = newGoalLevels.filter((_, i) => i !== index);
        newGoalLevelErrors = newGoalLevelErrors.filter((_, i) => i !== index);
      }
      return {
        ...prevState,
        formData: {
          ...prevState.formData,
          goalLevels: newGoalLevels,
        },
        errForm: {
          ...prevState.errForm,
          goalLevels: newGoalLevelErrors,
        },
      };
    });
  };

  handleExamDatesChange = (name: any,index:any) => (date: Date) => {
     let { formData,onTargetYearChange }: any = this.state;
     if(onTargetYearChange){
      formData.examDates[index][name] = "";
      return this.setState({ formData });
     }else if(name === "endDate"){
     formData.examDates[index][name] = date;
     return this.setState({ formData,minExpiryDate:date });
     }else{
      formData.examDates[index][name] = date;
      return this.setState({ formData });
     }
    
  };
  checkSameClassYear=()=>{
    let { formData} = this.state;
    const newFormData={...formData};
    let classYearMap:{[key:string]:string[]}={};
    newFormData.eligibleClasses.forEach((el)=>{
      const startDate=el.sessionStartTime;
      const className=_.get(el,"['class']['name']",'');
      if(className && classYearMap[className] && classYearMap[className].includes(startDate)){
          el.error="For this class this session year already exist";
      }else{
        classYearMap[className]=classYearMap[className]?[...classYearMap[className],startDate]:[startDate];
        el.error="";
      }
    });
   this.setState({formData:newFormData}); 
  }
  handleEligibleClassesChange = (evt: any, index: number) => {
    let { formData,sessionClassYearList} = this.state;
    const { classList } = this.state;
    const { name, value } = evt.target;
  
    if (name === "class") {
      const classObj = classList.find(
        (classObj: any) => classObj.name === value
      );
      index === -1 ? formData.eligibleClasses[index]["class"]["name"] = "select Class": formData.eligibleClasses[index]["class"]["name"] = value;
      index === -1 || _.isEmpty(classObj)?  "select": formData.eligibleClasses[index]["class"]["id"] = classObj._id;

     
    } else if (name === "sessionStartTime") {
      formData.eligibleClasses[index][name] = value;
      formData.eligibleClasses[index]["sessionEndTime"] = parseInt(value) + 1;
    }
      return this.setState({ formData},()=>{
        this.checkSameClassYear()
      });
  
  };

  handleCtaDisabled=()=>{
    const {actionType} = this.props;
    const {formData} = this.state
    if(actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL || actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL){
      const {
        hasError: hasGoalLevelErrors,
        errors: goalLevelErrors,
      } = validateGoalLevels(formData.goalLevels);
      let finalvalue:boolean = false;
      const checkClass = formData.eligibleClasses.map((classObj:any,index:any)=>{
        if(classObj.class.name == "select Class" || classObj.class.name ==""||classObj.error){
    return true
      }else{
         return false
       }
    })
    checkClass.map((value:any)=>{
      if(value == true){
        finalvalue = true
    return finalvalue
      }else{
        return finalvalue
      }
    })
    const validationForSwot = this.swotValidation();
       const validations = 
      !formData.name ||  (!formData.selectedCareerIds ||
        !formData.selectedCareerIds.length)  || formData.shortCode.length <=0 || formData.description.length<=12
       ||!formData.targetYear ||!formData.myPatGoalId || finalvalue || formData.endDate==="" || formData.businessTypes.length === 0||validationForSwot
      
    return  validations
    }else {
      return false
    }
   
    return false
  }

  swotValidation(){
    let { formData} = this.state
    if(formData.swotVisibility){
    const strengthValue = typeof(formData.swotVisibility.strength) ==="string" ? parseInt(formData.swotVisibility.strength):formData.swotVisibility.strength 
    const WeeknessValue = typeof(formData.swotVisibility.weakness) ==="string" ? parseInt(formData.swotVisibility.weakness):formData.swotVisibility.weakness
    const opportunityValue = typeof(formData.swotVisibility.opportunity) ==="string" ? parseInt(formData.swotVisibility.opportunity):formData.swotVisibility.opportunity
    const threatValue = typeof(formData.swotVisibility.threat) ==="string" ? parseInt(formData.swotVisibility.threat):formData.swotVisibility.threat
    if((_.isNaN(strengthValue) || strengthValue>365)||
    (_.isNaN(WeeknessValue)|| WeeknessValue>365)||
    (_.isNaN(opportunityValue)|| opportunityValue>365)||
    (_.isNaN(threatValue) || threatValue>365)){
      return true
    }
      else{
      return false
    }
  }else{
    return false
  }
  }
  createGoalClickHandler = async () => {
    if(this.props.isPostExpiryDays){
      this.props.toggleLicenseExpiredDialog(true)
    } else {
      const { formData, errForm } = this.state;
      const { dialogData, actionType } = this.props;
      const {
        ADD_NEW_GOAL,
        ADD_NEW_VERSION,
        EDIT_GOAL,
        EDIT_VERSION,
        DELETE_VERSION,
        DUPLICATE_GOAL,
      } = GOAL_ACTION_TYPE_CONST;
      this.setState({ errForm: INITIAL_ERROR_FORM_STATE });
      const { selectedCareerIds, removedCareerIds } = formData;
      if (actionType === ADD_NEW_GOAL) {
        const {
          hasError: hasGoalLevelErrors,
          errors: goalLevelErrors,
        } = validateGoalLevels(formData.goalLevels);
  
        if (!formData.name) {
          errForm.name = "Required *";
          this.setState({ errForm });
          return false;
        } else if (
          !formData.selectedCareerIds ||
          !formData.selectedCareerIds.length
        ) {
          errForm.careerType = "Required *";
          this.setState({ errForm });
          return false;
        } else if (hasGoalLevelErrors) {
          this.setState((prevState) => ({
            ...prevState,
            errForm: { ...prevState.errForm, goalLevels: goalLevelErrors },
          }));
          return false;
        }
        else if(formData.shortCode.length <=0){
          errForm.shortCode = "Required *";
          this.setState({ errForm });
       
        }
         else {
          const endDate = new Date(formData.endDate);
          let requestData = {
            name: formData.name,
            targetYear: formData.targetYear.toString(),
            description: formData.description,
            isV2: true,
            eligibility: this.changedEligibilityFinalObj(
              formData.eligibleClasses
            ),
            examDates: this.changedISOFormatExamDatesFinaObj(formData.examDates),
            swotVisibility:formData.swotVisibility,
            shortCode: formData.shortCode,
            endDate: endDate.toISOString(),
            goalLevels: formData.goalLevels
              .map(({ name, scale }) => {
                return { name: name.trim(), scale };
              })
              .filter(({ name, scale }) => name.length > 0 && scale > 0),
            selectedCareerIds,
            removedCareerIds,
            myPatGoalId:_.get(formData.myPatGoalId,"_id",""),
            businessTypes: formData.businessTypes,
            pastClasses: formData.pastClasses,
            courseImage: '',
          };
          try {
            const { courseImage } = formData;
            if(courseImage && typeof courseImage !== 'string') {
              // Upload to s3 first
              this.props.showLoader();
              formData.courseImage = await goalManagementService.handleCourseImageUpload(courseImage)
              this.props.hideLoader();
              requestData.courseImage = formData.courseImage
            }
            const resObj: any = await goalManagementService.createGoal(requestData);
    
            if (resObj.statusCode === 200) {
              this.props.getGoalList();
              this.props.dialogCloseHandler();
              this.props.history.push(
                `/goal-management/edit/${resObj.responseObject["_id"]}#${
                  resObj.responseObject["_id"]
                }`
              );
            }
          } catch (error) {
            console.error(error)
          }
        }
      } else if (actionType === EDIT_GOAL) {
        if(this.state.selectedGoalScale){
          this.props.showMsg("Change in goal level precedence is not permitted","error")
        }else{
          const {
            hasError: hasGoalLevelErrors,
            errors: goalLevelErrors,
          } = validateGoalLevels(formData.goalLevels);
    
          if (!formData.name) {
            errForm.name = "Required *";
            this.setState({ errForm });
            return false;
          } else if (
            !formData.selectedCareerIds ||
            !formData.selectedCareerIds.length
          ) {
            errForm.careerType = "Required *";
            this.setState({ errForm });
            return false;
          } else if (hasGoalLevelErrors) {
            this.setState((prevState) => ({
              ...prevState,
              errForm: { ...prevState.errForm, goalLevels: goalLevelErrors },
            }));
          } else {
            const newData = {
              name: formData.name,
              groupId: dialogData["groupId"],
              description: formData["description"],
              shortCode: formData["shortCode"],
              targetYear: formData["targetYear"],
              eligibility:formData.eligibleClasses,
              selectedCareerIds,
              removedCareerIds,
              examDates:formData.examDates,
              swotVisibility:formData.swotVisibility,
              endDate:formData.endDate,
              goalLevels:formData.goalLevels
              .map(({ name, scale, _id }) => {
                const data: any = { name: name.trim(), scale };
                if(_id) {
                  data._id = _id;
                }
                return data;
              })
              .filter(({ name, scale }) => name.length > 0 && scale > 0),
              oldMyPatGoalId:formData.myPatGoalId,
              newMyPatGoalId:formData.myPatGoalId,
              businessTypes: formData.businessTypes,
              pastClasses: formData.pastClasses,
              courseImage: ''
            };
            const { courseImage } = formData;
            if(courseImage && typeof courseImage !== 'string') {
              // Upload to s3 first
              this.props.showLoader();
              formData.courseImage = await goalManagementService.handleCourseImageUpload(courseImage)
              this.props.hideLoader();
              newData.courseImage = formData.courseImage
            } else if (courseImage) {
              newData.courseImage = courseImage
            }
             const resObj: any = await goalManagementService.updateGoal(newData);
            if (resObj.statusCode === 200) {
              this.props.getGoalList();
              this.props.dialogCloseHandler();
            }
          }
        }
       
      } else if (actionType === ADD_NEW_VERSION) {
        // call add new version api here
        const categoryId = _.get(dialogData.category,"id",[]);
        const shortCode = _.get(dialogData.courseType.id,"shortCode","")
        const name =_.get(dialogData.courseType,"name","")
         let requestData = {
          name: name,
          targetYear: formData.targetYear.toString(),
          groupId: dialogData.groupId,
          isV2: true,
          shortCode: shortCode,
          description:dialogData.description,
          eligibility: this.changedEligibilityFinalObj(formData.eligibleClasses),
          examDates: this.changedISOFormatExamDatesFinaObj(formData.examDates),
          businessTypes: formData.businessTypes,
          endDate: formData.endDate,
          selectedCareerIds:[categoryId],
          removedCareerIds,
          myPatGoalId:formData.myPatGoalId,
          baseVersionId: formData.baseVersionYear
        };
        ((requestData['baseVersionId'] || '').toUpperCase() === 'NA') && (delete requestData['baseVersionId']);
        const resObj: any = await goalManagementService.createGoal(requestData);
        if (resObj.statusCode === 200) {
          this.props.getGoalList();
          this.props.dialogCloseHandler();
        }
      } else if (actionType === EDIT_VERSION) {
        // call create api here
        if (!formData.name) {
          errForm.name = "Required *";
          this.setState({ errForm });
          return false;
        } else {
          let requestVersionData = {
            eligibility: this.changedEligibilityFinalObj(
              formData.eligibleClasses
            ),
            examDates: this.changedISOFormatExamDatesFinaObj(formData.examDates),
            endDate: formData.endDate,
            groupId: dialogData._id,
            targetyear:formData.targetYear,
            name:formData.name,
            selectedCareerIds,
            removedCareerIds,
          };
          const resObj: any = await goalManagementService.updateGoalVersion(
            requestVersionData
          );
          if (resObj.statusCode === 200) {
            this.props.getGoalList();
            this.props.dialogCloseHandler();
          }
        }
      }
    }
    
  };

  handleTentativeDate = () => {
    this.setState({
      isCheckedData: !this.state.isCheckedData,
    });
  };

  changedISOFormatExamDatesFinaObj = (dateArray: any) => {
    const parsedDate = (date: any) => new Date(date);
    return dateArray.map((dateObj: any) => ({
      startDate: parsedDate(dateObj["startDate"]).toISOString(),
      endDate: parsedDate(dateObj["endDate"]).toISOString(),
    }));
  };

  changedEligibilityFinalObj = (eligibilityArray: any) => {
    return eligibilityArray.map((eligibilityObj: any) => ({
      ...eligibilityObj,
      sessionStartTime: eligibilityObj["sessionStartTime"].toString(),
      sessionEndTime: eligibilityObj["sessionEndTime"].toString(),
      class: {
        ...eligibilityObj.class,
        name: ROMAN_CONSTANT[eligibilityObj["class"]["name"]],
      },
    }));
  };

  getLabels = (dialogData: any) => {
     const { actionType } = this.props;
    const {
      ADD_NEW_GOAL,
      ADD_NEW_VERSION,
      EDIT_GOAL,
      EDIT_VERSION,
      DELETE_VERSION,
      DUPLICATE_GOAL,
      READ_ONLY,
    } = GOAL_ACTION_TYPE_CONST;
    let data = {
      heading: "",
      submitButtonText: "",
      type: "",
    };

    if (actionType === ADD_NEW_GOAL) {
      data.heading = `Add Goal`;
      data.submitButtonText = "Create Goal";
      data.type = ADD_NEW_GOAL;
    }

    if (actionType === EDIT_VERSION) {
      data.heading = `Edit ${dialogData["name"]} Version`;
      data.submitButtonText = "Edit Version";
      data.type = EDIT_VERSION;
    }

    if (actionType === ADD_NEW_VERSION) {
      data.heading = `Add ${dialogData["courseType"]["name"]} New Version`;
      data.submitButtonText = "Create Version";
      data.type = ADD_NEW_VERSION;
    }

    if (actionType === DELETE_VERSION) {
      data.heading = `Delete ${dialogData["courseType"]["name"]}`;
      data.submitButtonText = "Delete Version";
      data.type = DELETE_VERSION;
    }

    if (actionType === DUPLICATE_GOAL) {
      data.heading = `Duplicate ${dialogData["courseType"]["name"]}`;
      data.submitButtonText = "Duplicate Goal";
      data.type = DUPLICATE_GOAL;
    }

    if (actionType === EDIT_GOAL) {
      data.heading = `Edit ${dialogData["courseType"]["name"]}`;
      data.submitButtonText = "Update Goal";
      data.type = EDIT_GOAL;
    }

    if (actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY) {
      data.heading = `${dialogData["courseType"]["name"]}`;
      data.type = READ_ONLY;
    }
    return data;
  };

  handleAddExamDates = (index:number) => {
    const examDates: any[] = [
      ...this.state.formData.examDates,
      {
        startDate: null,
        endDate: null,
      },
    ];
    this.setState({
      formData: {
        ...this.state.formData,
        examDates,
      },
    });
  };

  handleRemoveExamDates = (index: number) => {
    let lastIndexEndDate = new Date()
    const examDates: any[] = this.state.formData.examDates.filter(
      (_, itemIndex) => itemIndex !== index
    );
    if(examDates[examDates.length-1].endDate === null){
       lastIndexEndDate =examDates[examDates.length-2].endDate
    }else{
       lastIndexEndDate =examDates[examDates.length-1].endDate
    }
   
    this.setState({
      formData: {
        ...this.state.formData,
        examDates,
      },
     // minExpiryDate:lastIndexEndDate
    });
  };

  handleAddEligibleClasses = () => {
    const eligibleClasses: any[] = [
      ...this.state.formData.eligibleClasses,
      {
        sessionStartTime: new Date().getFullYear().toString(),
        sessionEndTime: (new Date().getFullYear() + 1).toString(),
        sessionInterval: "Yearly",
        class: {
          id: "",
          name: ""
        },
        error:""
      },
    ];
    this.setState({
      formData: {
        ...this.state.formData,
        eligibleClasses,
      },
    });
  };

  handleRemoveEligibleClasses = (index: number) => {
    const eligibleClasses: any[] = this.state.formData.eligibleClasses.filter(
      (_, itemIndex) => itemIndex !== index
    );
    this.setState({
      formData: {
        ...this.state.formData,
        eligibleClasses,
      },
    });
  };

  handleCareerTypeChange = ({ selectedCareerIds, removedCareerIds }: any) => {
    this.setState((prevState) => ({
      ...prevState,
      formData: { ...prevState.formData, removedCareerIds, selectedCareerIds },
    }));
  };

  render() {
    const {
      classes,
      isDialogOpen,
      dialogCloseHandler,
      dialogData,
      actionType,
    } = this.props;
     return (
      <Modal
        BackdropProps={{ invisible: true }}
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        hideBackdrop={true} //@Neeraj: try to follow the Material UI doc for UI Arch
        className={[
          classes.fontSizeLG,
          classes.fontWeight500,
          classes.modal,
        ].join(" ")}
        // title={this.getLabels(dialogData).heading}
        // @shivam title already implemented in card header
        open={isDialogOpen}
      >
        <div className={classes.paper}>
          <Card elevation={0} classes={{root: classes.lightGrey}}>
            <CardHeader
              className={classes.modalHeader}
              action={
                <IconButton aria-label="settings" onClick={dialogCloseHandler}>
                  <CloseIcon className={classes.fontSizeLG} />
                </IconButton>
              }
              title={
                <Typography
                  align="left"
                  className={[
                    classes.fontWeight500,
                    classes.title,
                    classes.fontSizeLG,
                  ].join(" ")}
                >
                  {this.getLabels(dialogData).heading}
                </Typography>
              }
            />
            <CardContent className={classes.fullMinHeight}>
              <Grid
                container
                spacing={8}
                alignItems="center"
                className={classes.cardContainer}
              >
                  {this.renderForm()}
              </Grid>
              
            </CardContent>
            {actionType !== GOAL_ACTION_TYPE_CONST.READ_ONLY ? (
                <div className={classes.footerFixed}>
                  <Grid item container justify="flex-end" alignItems="flex-end">
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.btnCreateGoal}
                     disabled={this.handleCtaDisabled()}
                      onClick={this.createGoalClickHandler}
                    >
                      {this.getLabels(dialogData).submitButtonText}
                    </Button>
                  </Grid>
                </div>
              ) : null}
          </Card>
        </div>
      </Modal>
    );
  }

  renderForm() {
    const { classes, actionType } = this.props;
    const isEligibleClassesVisible = () => {
      return (
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
      );
    };
    const disabledEditColumn = () =>{
      return (
       actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL 
      );
    };
    const StepperForm = (
      <Stepper
        orientation="vertical"
        classes={{root: classes.lightGrey}}
        connector={<StepConnector classes={{ line: classes.connector }} />}
      >
        <Step active>
          <StepLabel
            icon={
              <img
                className={classes.labelCustomIcon}
                src="/assets/svg/goalManagement/basic-information.svg"
              />
            }
            className={classes.stepLabelTitle}
          >
            Basic Information
          <span className={classes.error}>*</span>
          </StepLabel>
          <StepContent className={cx(classes.stepContentStyle, this.state.isBasicFocus && classes.activeStep)} 
          // onFocus={this.handleBasicFocus.bind(this)}
          >
            {this.renderBasicInformation()}
          </StepContent>
        </Step>
        {/* {isEligibleClassesVisible() && ( */}
          <Step active className={classes.stepLabelTitle}>
            <StepLabel
              icon={
                <img
                  className={classes.labelCustomIcon}
                  src={disabledEditColumn()?"/assets/svg/goalManagement/elligible-classes.svg":"/assets/svg/Group 6733.svg"}
                />
              }
              className={classes.stepLabelTitle}
            >
              Eligible Classes
            </StepLabel>
            <StepContent
              className={[classes.stepContentStyle, this.state.isClassesFocus && classes.activeStep, classes.spacingFix].join(
                " "
              )}
              onFocus={this.handleClassesFocus.bind(this)}
            >
              {this.renderEligibleClasses()}
              <div className={classes.margin2x}>
                {this.renderPastClasses()}
              </div>
            </StepContent>
          </Step>
        {/* )} */}
        <Step active className={classes.stepLabelTitle}>
          <StepLabel
            icon={
              <img
                className={classes.labelCustomIcon}
                src="/assets/svg/goalManagement/goal-level.svg"
              />
            }
            className={classes.stepLabelTitle}
          >
            Add goal level
          </StepLabel>
          <StepContent className={cx(classes.stepContentStyle, 
            this.state.isGoalFocus && classes.activeStep)}
            // onFocus={this.goalLevelFocus.bind(this)}
            >
            {this.renderAddGoalLevel()}
          </StepContent>
        </Step>
      </Stepper>
    );
    const OldForm = (
      <>
        {this.renderBasicInformation()}
        {this.renderEligibleClasses()}
      </>
    );
    const isAddingOrEditingGoal =
      actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
      actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL;

    return isAddingOrEditingGoal ? StepperForm : OldForm;
  }

  handleBasicFocus() {
    this.setState({isBasicFocus: true, isClassesFocus: false, 
      isGoalFocus: false});
  }

  handleClassesFocus() {
    this.setState({isBasicFocus: false, 
      isClassesFocus: true, isGoalFocus: false});
  }

  goalLevelFocus() {
    this.setState({isBasicFocus: false, 
      isClassesFocus: false, isGoalFocus: true});
  }

  handleBusinessTypeChange = (event: any) => {
    const selectedBusinessTypes: string[] = event.target.value;
    const businessTypes = selectedBusinessTypes.map(name => ({ name }))
    this.setState(prevState => ({ ...prevState, formData: { ...prevState.formData, businessTypes: businessTypes } }))
  }

  handleBaseVersionChange = (event: any) => {
    const baseVersionYear = event.id;
    this.setState((prevState: { formData: any; }) => ({ ...prevState, formData: { ...prevState.formData, baseVersionYear } }))
  }

  handleCourseImage = (attachment: Attachment) => {
    this.setState(prevState => ({ ...prevState, formData: { ...prevState.formData, courseImage: attachment } }))
  }

  renderCourseImagePreviewItem = ({ url, extension, fileName, size } : PreviewItem) => {
    const { classes } = this.props;
    const fileNameWithExt = `${fileName}.${extension}`;
    return (
      <Grid style={{maxWidth: '96%'}} key={fileNameWithExt} container alignItems="center" className={cx(classes.courseImageContainer, classes.greyBorder)}>
        <Grid item xs="auto"  className={classes.imgContainer}>
          <img src={url} alt="course-logo" width={100} />
          <IconButton onClick={() => this.handleCourseImage('')} className={cx(classes.editIconContainer, classes.greyBorder)}>
            <EditIcon fontSize="inherit" color="primary" />
          </IconButton>
        </Grid>
        <Grid item xs className={cx(classes.fontSizeMD, classes.greyText)}>
          <Typography variant="body1" gutterBottom>
            {fileNameWithExt}
          </Typography>
          {size && (
            <Typography variant="body1" gutterBottom>
              {Math.round(size / 1024)} KB
            </Typography>
          )}
        </Grid>
        <Grid item xs="auto">
          <div className={classes.doneIconContainer}>
            <DoneIcon fontSize="inherit" color="inherit" />
          </div>
        </Grid>
      </Grid>
    );
  }

  renderCourseImagePreview = () => {
    const { courseImage } = this.state.formData;
    if(!courseImage) {
      return null;
    }
    const list = [convertFileOrUrlToPreviewItem(courseImage)];

    return (
      <MyPATUploadPreview
        list={list}
        readOnly
        renderAttachmentItem={this.renderCourseImagePreviewItem}
      />
    );
  }


  renderCourseImageUploader = () => {
    const { classes } = this.props;
    return (
      <MyPATUploader 
        accept="image/*" 
        multiple={false} 
        maxNoOfSelections={1} 
        allowedFileTypes={ALLOWED_COURSE_IMAGE_TYPES}
        maxFileSize={1024 * 1024 * 2} // 2 MB
        minFileSize={1024 * 10} // 10 KB
        maxDimensions={MAX_COURSE_IMAGE_DIMENSIONS}
        onChange={(attachments: Attachment[]) => this.handleCourseImage(attachments[0])}
      >
        {({ accept, handleFileChange, multiple, error, errorMsg }) => {
          return (
            <>
            {error && (
              <Typography gutterBottom variant="body1" className={classes.error}>
                {errorMsg}
              </Typography>
            )}
            <Grid container alignItems="center" className={cx(classes.courseImageContainer, classes.greyBorder)}>
              <Grid item xs="auto">
                <img src="/assets/svg/placeholder-img.svg" alt="upload" width={40} />
              </Grid>
              <Grid item xs className={cx(classes.fontSizeMD, classes.greyText)} style={{fontSize: '15px',marginLeft: '20px'}}>
                Upload .PNG or .JPG or .SVG image <br/>
                {`(10 KB - 2 MB & < 800 * 400 pixels)`}
              </Grid>
              <Grid item xs="auto">
                <label htmlFor="courseImage" className={cx(classes.fontSizeMD, classes.courseImageUploadBtn)}>Browse File</label>
                <input
                  id="courseImage"
                  aria-describedby="Upload course Image"
                  type="file"
                  accept={accept || ""}
                  onChange={handleFileChange}
                  multiple={multiple || false}
                  className={classes.inputFile}
                />
              </Grid>
            </Grid>
            
          </>
          );
        }}
      </MyPATUploader>
    );
  }

  renderBasicInformation() {
    const { classes, dialogData, actionType } = this.props;
    const { formData, errForm,goalCategory } = this.state;
    let availableVersions: { name: string; id: string; }[] = [];
    ((dialogData || [])['courseData'] || []).forEach((el:{targetYear:string, id: string, status:string}) => ((el.status || '').toUpperCase() !== 'DRAFT') && (availableVersions.push({name: el.targetYear, id: el.id})));
    // removing duplicate versions and sorting in descreasing order:
    if(availableVersions.length){
      let uniqueVersions = {};
      availableVersions.forEach(el => {
        if(!(el.name in uniqueVersions)){
          //@ts-ignore
          uniqueVersions[el.name] = el;
        }
      });
      availableVersions = Object.values(uniqueVersions);
      availableVersions.sort((a,b) => (+b.name) - (+a.name));
    }
    let { minExpiryDate } = this.state
    const maxDate =  _.isEmpty(formData.targetYear) ?new Date():new Date(formData.targetYear);
    const year = maxDate.getFullYear();
    const month = maxDate.getMonth();
    const minExpiry = new Date(year -1, month,1);
   const maxExpiry=new Date(year + 1, month+1,0);
    const { examDates } = formData;
    const isdefaultTargetYear = actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL || actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION;
   const isGoalNameShortCodeDescriptionVisible = () => {
      return (
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
        actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL ||
        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
      );
    };

    const isExpiryDateVisible = () => {
      return (
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
      );
    };

    const isExamDatesVisible = () => {
      return (
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL ||
        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
      );
    };  

    const isAddNewVersion=()=>{
      return  actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
      actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION 
    }
    const isBusinessTypeVisible = actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL || actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL;
    const minimunFromDateYear= new Date(formData.endDate).getFullYear();
    const minimunFrom= new Date(minimunFromDateYear,0,1)
    const minimumFormDate = minimunFrom.toString() === 'Invalid Date' && minimunFromDateYear.toString() ==='NaN'?new Date:minimunFrom

    return (
      <>
        {isGoalNameShortCodeDescriptionVisible() ? (
          <>
            <Grid
              container
              className={classes.paddingLeft}
              justify="space-between"
              alignItems="center"
            >
              <Grid item xs={6}>
                <Grid
                  className={cx(classes.paddingRight, classes.height81)}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={cx(classes.fontSizeMD, classes.labelText)}
                  >
                    New Goal Name &nbsp;
                    <span className={classes.error}>*</span>
                  </Typography>
                  <MyPATTextField
                    fullWidthControl
                    inputId="name"
                    name="name"
                    error={errForm.name != "" ? true : false}
                    errorText={errForm.name}
                    placeholder="Type Goal Name"
                    disabled={
                      actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                    }
                    value={formData.name || ""}
                    onChange={this.handleInputChange.bind(this)}
                    onFocus={this.handleBasicFocus.bind(this)}
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid className={classes.height81}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={cx(classes.fontSizeMD, classes.labelText)}
                  >
                    Short Code &nbsp;
                    <span className={classes.error}>*</span>
                    <span className={classes.iconStyle}>
                      <CustomInfoIcon
                        isInfoIcon={true}
                        isRightArrow={false}
                        isCenterArrow={true}
                        knowMoreAbout={false}
                        dialogTitle="Short Code"
                        imageURL="/assets/svg/shortCode.svg"
                        details="Click to know more"
                        toolTipDirection="top"
                        dialogPara=""
                        htmlElement={
                          <>
                            <Grid container justify="flex-start">
                              <Typography className={classes.popupContent}>
                                Short code is a short name for each goal.
                              </Typography>
                            </Grid>
                          </>
                        }
                      />
                    </span>
                  </Typography>
                  <MyPATTextField
                    fullWidthControl
                    inputId="shortCode"
                    name="shortCode"
                    onKeyPress={this.preventShortCodeMaxLength.bind(this)}
                    errorText={errForm.name}
                    placeholder="Max 6 Characters"
                    disabled={
                      actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                    }
                    value={formData.shortCode || ""}
                    onChange={this.handleInputChange.bind(this)}
                    helperText="Short Code should be of max 6 characters."
                    onFocus={this.handleBasicFocus.bind(this)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container className={classes.paddingLeft}>
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  gutterBottom
                  className={cx(classes.fontSizeMD, classes.labelText)}
                >
                  Upload Logo
                </Typography>
                {formData.courseImage
                  ? this.renderCourseImagePreview()
                  : this.renderCourseImageUploader()}
              </Grid>

              <Grid item xs={12}>
                <Grid
                  container
                  // className={[classes.mb1x, classes.paddingLeft].join(" ")}
                >
                  <CareerTypeField
                    errorText={errForm.careerType}
                    disabled={
                      actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                    }
                    classes={classes}
                    onChange={this.handleCareerTypeChange}
                    courseTypeId={
                      dialogData &&
                      dialogData.courseType &&
                      dialogData.courseType.id._id
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            {isBusinessTypeVisible && (
              <Grid
                item
                container
                justify="space-between"
                className={[
                  classes.mb1x,
                  classes.paddingLeft,
                  classes.margin2x,
                ].join(" ")}
              >
                <Grid item xs={12} className={cx(classes.mb1x)}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={cx(classes.fontSizeMD, classes.labelText)}
                  >
                    Business Type &nbsp;
                    <span className={classes.error}>*</span>
                  </Typography>
                  <div>
                    <MyPATSelect
                      multiple={true}
                      isNative={false}
                      fullWidthControl
                      name="businessType"
                      value={formData.businessTypes.map(({ name }) => name)}
                      onChange={this.handleBusinessTypeChange}
                      displayEmpty
                      customRenderFunc={() => {
                        return formData.businessTypes
                          .map(({ name }) => {
                            const businessType = BUSINESS_TYPES.find(
                              ({ value }) => value === name
                            );
                            return businessType ? businessType.label : "";
                          })
                          .join(", ");
                      }}
                      placeholder={
                        <Typography
                          variant="body2"
                          align="left"
                          inline
                          className={classes.greyText}
                        >
                          Select Business type
                        </Typography>
                      }
                      required
                    >
                      {BUSINESS_TYPES.map(({ label, value }) => (
                        <MenuItem value={value} key={value}>
                          <Checkbox
                            color="primary"
                            checked={
                              !!formData.businessTypes.find(
                                ({ name }) => name === value
                              )
                            }
                          />
                          <ListItemText primary={label} />
                        </MenuItem>
                      ))}
                    </MyPATSelect>
                  </div>
                </Grid>
              </Grid>
            )}

            <Grid
              container
              justify="space-between"
              className={[
                classes.mb1x,
                classes.paddingLeft,
                classes.margin2x,
              ].join(" ")}
            >
              <Typography
                variant="body1"
                gutterBottom
                className={cx(classes.fontSizeMD, classes.labelText)}
              >
                Description &nbsp;<span className={classes.error}>*</span>
              </Typography>

              <div className={classes.joditEditorBlock}>
                <textarea
                  id="editor"
                  name="editor"
                  onFocus={this.handleBasicFocus.bind(this)}
                />
              </div>
            </Grid>

            <Grid
              container
              className={[classes.paddingLeft, classes.margin2x].join(" ")}
            >
              <Grid item xs={4}>
                <Grid
                  // item
                  // xs={6}
                  className={[
                    classes.mb1x,
                    classes.paddingRight,
                    actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                      ? cx(classes.disableOpacity)
                      : "",
                  ].join(" ")}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={cx(classes.fontSizeMD, classes.labelText)}
                  >
                    Select Target Year &nbsp;
                    <span className={classes.error}>*</span>
                  </Typography>
                  <Grid className={classes.dropDownCont}>
                    <MyPATDropdown
                      placeholder="Select Target year"
                      dropdownItems={dialogData.getCurrentYear}
                      selectedItem={formData.targetYear}
                      disabled={
                        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                        actionType ===
                          GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
                        !isExpiryDateVisible()
                      }
                      onChange={this.handleTargetChange.bind(this)}
                      labelKey="targetYear"
                      valueKey="year"
                      onFocus={this.handleBasicFocus.bind(this)}
                      isDisabled={
                        actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                        !isExpiryDateVisible()
                          ? true
                          : false
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid
                  // item
                  // xs={6}
                  className={[
                    classes.mb1x,
                    classes.paddingRight,
                    actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                      ? cx(classes.disableOpacity)
                      : "",
                  ].join(" ")}
                >
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={cx(classes.fontSizeMD, classes.labelText)}
                  >
                    Goal Expiry Date &nbsp;
                    <span className={classes.error}>*</span>
                  </Typography>
                  <Grid className={classes.calenderContainer}>
                  <MyPATCalendar
                    fullWidthControl
                    onChange={this.handleExipryChange.bind(this)}
                    date={formData.endDate}
                    placeholder="Expiry date"
                    minDate={minExpiry}
                    onFocus={this.handleBasicFocus.bind(this)}
                    maxDate={maxExpiry}
                    disabled={
                      actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                      !isExpiryDateVisible()
                    }
                    className={[
                      !isExpiryDateVisible()
                        ? cx(classes.examDateDisabled)
                        : classes.examDate,
                    ].join(" ")}
                  />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={4}>
                <Grid
                  // container
                  className={[
                    classes.mb1x,
                    // classes.paddingRight,
                    actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION
                      ? cx(classes.margin0, classes.disableOpacity)
                      : cx(
                          // classes.margin2x,
                          actionType ===
                            GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
                            actionType ===
                              GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL
                            ? classes.padding0
                            : " "
                        ),
                    actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                      ? cx(classes.disableOpacity)
                      : "",
                    !isExpiryDateVisible() ? classes.disableState : "",
                  ].join(" ")}
                >
                  <Grid className={cx(classes.mb1x)}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={cx(classes.fontSizeMD, classes.labelText)}
                    >
                      Select Glorifire Goal &nbsp;
                      <span className={classes.error}>*</span>
                    </Typography>
                    <Grid className={classes.dropDownCont}>
                      <MyPATDropdown
                        placeholder="Select Category"
                        dropdownItems={goalCategory}
                        disabled={
                          (actionType ===
                            GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                            !isExpiryDateVisible()) &&
                          !!formData.myPatGoalId
                        }
                        selectedItem={formData.myPatGoalId}
                        onChange={this.handleCategoryChange.bind(this)}
                        labelKey="displayName"
                        valueKey="_id"
                        onFocus={this.handleBasicFocus.bind(this)}
                        isDisabled={
                          (actionType ===
                            GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                            !isExpiryDateVisible()) &&
                          !!formData.myPatGoalId
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid
              container
              className={[
                classes.mb1x,
                classes.paddingLeft,
                actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION
                  ? cx(classes.margin0, classes.disableOpacity)
                  : cx(
                      classes.margin2x,
                      actionType ===
                        GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION ||
                        actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL
                        ? classes.paddingRight
                        : ""
                    ),
                actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                  ? cx(classes.paddingRight35, classes.disableOpacity)
                  : "",
                !isExpiryDateVisible() ? classes.disableState : "",
              ].join(" ")}
            >
              <Grid item xs={12} className={cx(classes.mb1x)}>
                <Typography
                  variant="body1"
                  gutterBottom
                  className={cx(classes.fontSizeMD, classes.labelText)}
                >
                  Select myPat Goal &nbsp;
                  <span className={classes.error}>*</span>
                </Typography>
                <Grid>
                  <MyPATDropdown
                    placeholder="Select Category"
                    dropdownItems={goalCategory}
                    disabled={
                      (actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                        !isExpiryDateVisible()) &&
                      !!formData.myPatGoalId
                    }
                    selectedItem={formData.myPatGoalId}
                    onChange={this.handleCategoryChange.bind(this)}
                    labelKey="displayName"
                    valueKey="_id"
                    onFocus={this.handleBasicFocus.bind(this)}
                    isDisabled={
                      (actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                        !isExpiryDateVisible()) &&
                      !!formData.myPatGoalId
                    }
                  />
                </Grid>
              </Grid>
            </Grid> */}
          </>
        ) : null}

        <Grid
          item
          container
          justify="space-between"
          className={[
            classes.mb1x,
            classes.paddingLeft,
            // classes.margin2x,
          ].join(" ")}
        >
          {/* {isTargetYearVisible() ? ( */}
          {/* <Grid
            item
            xs={6}
            className={[
              classes.mb1x,
              classes.paddingRight35,
              actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                ? cx(classes.paddingRight35, classes.disableOpacity)
                : "",
            ].join(" ")}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={cx(classes.fontSizeMD, classes.labelText)}
            >
              Select Target Year &nbsp;
              <span className={classes.error}>*</span>
            </Typography>
            <Grid>
              <MyPATDropdown
                placeholder="Select Target year"
                dropdownItems={dialogData.getCurrentYear}
                selectedItem={formData.targetYear}
                disabled={
                  actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                  actionType === GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
                  !isExpiryDateVisible()
                }
                onChange={this.handleTargetChange.bind(this)}
                labelKey="targetYear"
                valueKey="year"
                onFocus={this.handleBasicFocus.bind(this)}
                isDisabled={
                  actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                  !isExpiryDateVisible()
                    ? true
                    : false
                }
              />
            </Grid>
          </Grid> */}
          {/* <Grid
            item
            xs={6}
            className={[
              classes.mb1x,
              actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                ? cx(classes.disableOpacity)
                : "",
            ].join(" ")}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={cx(classes.fontSizeMD, classes.labelText)}
            >
              Goal Expiry Date &nbsp;
              <span className={classes.error}>*</span>
            </Typography>
            <MyPATCalendar
              fullWidthControl
              onChange={this.handleExipryChange.bind(this)}
              date={formData.endDate}
              placeholder="Expiry date"
              minDate={minExpiry}
              onFocus={this.handleBasicFocus.bind(this)}
              maxDate={maxExpiry}
              disabled={
                actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                !isExpiryDateVisible()
              }
              className={[
                !isExpiryDateVisible()
                  ? cx(classes.examDateDisabled)
                  : classes.examDate,
              ].join(" ")}
            />
          </Grid> */}
          
          <div className={cx(classes.closeContainer, classes.margin2x)}>
            {isGoalNameShortCodeDescriptionVisible() ? (
              <>
                 
          <Grid container>
            <Grid item xs={12}>
              <Grid className={classes.halfBorder}>
                <Typography>SWOT Visiblity Before</Typography>
              </Grid>
            </Grid>
          </Grid>
                <Grid
                style={{marginLeft: '-5px'}}
                  container
                  // className={classes.swotContainer}
                  justify="space-between"
                  alignItems="center"
                  // spacing={16}
                >
                  <Grid item xs={3}>
                    <Grid
                      className={cx(
                        classes.height80,
                        classes.swotContainer
                      )}
                    >
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={cx(
                          classes.fontSizeMD,
                          classes.labelText
                        )}
                      >
                        Strength &nbsp;
                      </Typography>
                      <MyPATTextField
                       fullWidthControl
                        inputId="Strength"
                        name="Strength"
                        placeholder="Days"
                        inputProps={{ min: 1 }}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY 
                        }
                        value={
                          formData.swotVisibility &&
                          formData.swotVisibility.strength
                        }
                        onChange={this.handleSwotChange.bind(this)}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      className={cx(
                        classes.height80,
                        classes.swotContainer
                      )}
                    >
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={cx(
                          classes.fontSizeMD,
                          classes.labelText
                        )}
                      >
                        Weekness &nbsp;
                      </Typography>
                      <MyPATTextField
                        fullWidthControl
                        inputId="Weekness"
                        name="Weekness"
                        placeholder="Days"
                        inputProps={{
                          min: 0,
                          max: 365,
                        }}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                        }
                        value={
                          formData.swotVisibility &&
                          formData.swotVisibility.weakness
                        }
                        onChange={this.handleSwotChange.bind(this)}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      className={cx(
                        classes.height80,
                        classes.swotContainer
                      )}
                    >
                      <Typography
                        style={{marginleft: '10px'}}
                        variant="body1"
                        gutterBottom
                        className={cx(
                          classes.fontSizeMD,
                          classes.labelText
                        )}
                      >
                        Opportunity &nbsp;
                      </Typography>
                      <MyPATTextField
                        fullWidthControl
                       inputId="Opportunity"
                        name="Opportunity"
                        placeholder="Days"
                        inputProps={{
                          min: 0,
                          max: 365,
                        }}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                        }
                        value={
                          formData.swotVisibility &&
                          formData.swotVisibility.opportunity
                        }
                        onChange={this.handleSwotChange.bind(this)}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      className={cx(
                        classes.height80,
                        classes.swotContainer
                      )}
                    >
                      <Typography
                      style={{marginLeft: '30px'}}
                        variant="body1"
                        gutterBottom
                        className={cx(
                          classes.fontSizeMD,
                          classes.labelText
                        )}
                      >
                        Threats &nbsp;
                      </Typography>
                      <MyPATTextField
                        fullWidthControl
                        inputId="Threats"
                        name="Threats"
                        placeholder="Days"
                        inputProps={{
                          min: 0,
                          max: 365,
                        }}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY
                        }
                        value={
                          formData.swotVisibility &&
                          formData.swotVisibility.threat
                        }
                        onChange={this.handleSwotChange.bind(this)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </div>
          {
            isAddNewVersion() &&
            <>
              <Grid container>
                <Grid item xs={6}>
                  <Grid
                    // item
                    // xs={6}
                    className={[
                      classes.mb1x,
                      classes.paddingRight,
                      actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                        ? cx(classes.disableOpacity)
                        : "",
                    ].join(" ")}
                  >
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={cx(classes.fontSizeMD, classes.labelText)}
                    >
                      Select Target Year &nbsp;
             <span className={classes.error}>*</span>
                    </Typography>
                    <Grid className={classes.dropDownCont}>
                      <MyPATDropdown
                        placeholder="Select Target year"
                        dropdownItems={dialogData.getCurrentYear}
                        selectedItem={formData.targetYear}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                          actionType ===
                          GOAL_ACTION_TYPE_CONST.EDIT_VERSION ||
                          !isExpiryDateVisible()
                        }
                        onChange={this.handleTargetChange.bind(this)}
                        labelKey="targetYear"
                        valueKey="year"
                        onFocus={this.handleBasicFocus.bind(this)}
                        isDisabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                            !isExpiryDateVisible()
                            ? true
                            : false
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid
                    // item
                    // xs={6}
                    className={[
                      classes.mb1x,
                      classes.paddingRight,
                      actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                        ? cx(classes.disableOpacity)
                        : "",
                    ].join(" ")}
                  >
                    <Typography
                      variant="body1"
                      gutterBottom
                      className={cx(classes.fontSizeMD, classes.labelText)}
                    >
                      Goal Expiry Date &nbsp;
                    <span className={classes.error}>*</span>
                    </Typography>
                    <Grid className={classes.calenderContainer}>
                      <MyPATCalendar
                        fullWidthControl
                        onChange={this.handleExipryChange.bind(this)}
                        date={formData.endDate}
                        placeholder="Expiry date"
                        minDate={minExpiry}
                        onFocus={this.handleBasicFocus.bind(this)}
                        maxDate={maxExpiry}
                        disabled={
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                          !isExpiryDateVisible()
                        }
                        className={[
                          !isExpiryDateVisible()
                            ? cx(classes.examDateDisabled)
                            : classes.examDate,
                        ].join(" ")}
                      />
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
              <Grid container>
                <Grid item xs={6}>
                  <Grid className={[
                    classes.mb1x,
                    classes.paddingRight,
                    !availableVersions.length && classes.isDisabled
                    ].join(" ")}>
                      <Typography variant="body1" gutterBottom className={cx(classes.fontSizeMD, classes.labelText)}>Select Base Version Year</Typography>
                      <MyPATDropdown placeholder="Select Base Version Year" dropdownItems={availableVersions} selectedItem={null} onChange={this.handleBaseVersionChange} labelKey="name" valueKey="id" disabled={!availableVersions.length} isDisabled={!availableVersions.length}/>
                  </Grid>
                </Grid>
              </Grid>
            </>
          }
          <div className={cx(classes.closeContainer, classes.margin2x)}>
            <Grid
              item
              xs={12}
              className={[
                // classes.margin2x,
                actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
                  ? cx(classes.disableOpacity)
                  : "",
              ].join(" ")}
            >
              <Grid container style={{marginBottom: '20px'}}>
                <Grid item xs={12}>
                  <Grid className={classes.halfBorder}>
                    <Typography>Exam Date</Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Typography
                variant="body1"
                gutterBottom
                className={cx(classes.fontSizeMD, classes.labelText)}
              >
                Exam Date &nbsp;<span className={classes.error}>*</span>
              </Typography> */}
              {examDates.map((examDateObj: any, index: number) => {
                return (
                  <>
                    <Grid
                      container
                      justify="space-between"
                      className={classes.mb1x}
                    >
                      <Grid
                        item
                        xs={6}
                        className={[classes.examDateRange].join(" ")}
                      >
                        <span>From</span>
                        <Grid className={classes.calenderContainer}>
                        <MyPATCalendar
                          fullWidthControl
                          name="startDate"
                          onChange={this.handleExamDatesChange(
                            "startDate",
                            index
                          )}
                          date={
                            formData.examDates[index]["startDate"] === null
                              ? null
                              : formData.examDates[index]["startDate"]
                          }
                          placeholder="From Date"
                          minDate={index < 1 ? minExpiry : minExpiryDate}
                          maxDate={formData.endDate}
                          onFocus={this.handleBasicFocus.bind(this)}
                          className={[
                            !isExpiryDateVisible()
                              ? cx(classes.examDateDisabled)
                              : classes.examDate,
                          ].join(" ")}
                          disabled={
                            actionType ===
                              GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                            !isExamDatesVisible() ||
                            !formData.endDate
                          }
                        />
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={[classes.examDateRange].join(" ")}
                      >
                        <span className={classes.spaceMargin}>To</span>
                        <div className={classes.calenderContainer}>
                          <MyPATCalendar
                            isCustomMargin={true}
                            fullWidthControl
                            onChange={this.handleExamDatesChange(
                              "endDate",
                              index
                            )}
                            date={
                              formData.endDate === ""
                                ? (formData.examDates[index][
                                    "endDate"
                                  ] = null)
                                : formData.examDates[index]["endDate"]
                            }
                            placeholder="Exam Date to"
                            onFocus={this.handleBasicFocus.bind(this)}
                            minDate={formData.examDates[index]["startDate"]}
                            maxDate={formData.endDate}
                            disabled={
                              actionType ===
                                GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                              !isExamDatesVisible() ||
                              !formData.endDate ||
                              !formData.examDates[index]["startDate"]
                            }
                            isDisable={
                              actionType ===
                                GOAL_ACTION_TYPE_CONST.READ_ONLY ||
                              !isExamDatesVisible()
                            }
                            className={[
                              !isExpiryDateVisible()
                                ? cx(classes.examDateDisabled)
                                : classes.examDate,
                            ].join(" ")}
                          />
                        </div>
                        {index !== 0 ? (
                          <IconButton
                            onClick={() =>
                              this.handleRemoveExamDates(index)
                            }
                            // className={classes.cancelIconStyle}
                            className={classes.dateCloseButton}
                          >
                            <CloseOutlinedIcon
                              className={classes.fontSizeMD}
                            />
                          </IconButton>
                        ) : null}
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      justify="flex-end"
                      className={classes.mb1x}
                    >
                      {index === examDates.length - 1 &&
                      isExamDatesVisible() ? (
                        <Button
                          disabled={!formData.examDates[index]["endDate"]}
                          className={classes.addMoreStyle}
                          onClick={() => this.handleAddExamDates(index)}
                        >
                          Add More
                        </Button>
                      ) : null}
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </div>
        </Grid>
      </>
    );
  }

  handlePastClasses = (event: any) => {
    const selectedClassKeys: string[] = event.target.value;
    const { classList } = this.state;
    const selectedPastClasses = selectedClassKeys.map((classKey) => {
      const classObj = classList.find(
        (classObj: any) => classObj.name === ROMAN_CONSTANT_REVERSE[classKey]
      );
      if(!classObj) {
        return null;
      }
      return { id: classObj._id, name: classKey }
    }).filter(pastClass => !!pastClass)
    this.setState(prevState => ({ ...prevState, formData: { ...prevState.formData, pastClasses: selectedPastClasses } }))
  }

  renderPastClasses = () => {
    const { formData, errForm } = this.state;
    const { classes } = this.props;
    // const selectedEligibleClassesSet = new Set(
    //   formData.eligibleClasses.map(eligibleClass => {
    //     return ROMAN_CONSTANT[_.get(eligibleClass, 'class.name', '')];
    //   })
    // );

    // const availablePastClasses = Object.keys(ROMAN_CONSTANT_REVERSE).filter((classKey) => !selectedEligibleClassesSet.has(classKey))
    const availablePastClasses = Object.keys(ROMAN_CONSTANT_REVERSE)

    return (
      <OutLineDiv label="Past Class(es)">
        <MyPATSelect
          multiple={true}
          isNative={false}
          fullWidthControl
          name="pastClasses"
          value={formData.pastClasses.map(({ name }) => name)}
          onChange={this.handlePastClasses}
          displayEmpty
          customRenderFunc={() => formData.pastClasses.map(pastClass => pastClass.name).join(', ')}
          placeholder={
            <Typography
              variant="body2"
              align="left"
              inline
              className={classes.greyText}
            >
              Select past class(es)
            </Typography>
          }
          required
          // error={errForm.}
        >
          {availablePastClasses.map((classKey) => (
            <MenuItem value={classKey} key={classKey}>
              <Checkbox
                color="primary"
                checked={!!formData.pastClasses.find(({ name }) => name === classKey)}
              />
              <ListItemText primary={classKey} />
            </MenuItem>
          ))}
        </MyPATSelect>
      </OutLineDiv>
    );
  }

   sessionStartTimeYearList = () => {
      let { formData,sessionClassYearList } = this.state
    const currentYear: number = new Date().getFullYear();
    const targetYear: number =
      parseInt(formData.targetYear) ||
      parseInt(formData.targetYear);
    let sessionStartTimeYearArray = [];
    const  sessionclassList:any =[];
    const sessionClassWiseYear:any=[];
 
    if (targetYear > currentYear) {
      for (let i = currentYear; i < targetYear; i++) {
        sessionStartTimeYearArray.push(i.toString());
      }
    } else {
      for (let i = targetYear - 1; i < targetYear; i++) {
        sessionStartTimeYearArray.push(i.toString());
      }
    }
  //  return sessionStartTimeYearArray
      //  if(formData.eligibleClasses.length>1){  
      //    formData.eligibleClasses.map((res:any,index:number)=>{
      //      if(sessionclassList.includes(res.class.name)){
      //          //console.log(res[index-1])
      //          for(let i=0;i<index;i++){
      //            sessionClassWiseYear.push(formData.eligibleClasses[i].sessionStartTime.toString())
      //          }
      //  }
      //    sessionclassList.push(res.class.name)
      //    })
      //    sessionStartTimeYearArray  = _.difference(sessionStartTimeYearArray, sessionClassWiseYear);
      //  }
      return sessionStartTimeYearArray
      // this.setState({
      //   sessionClassYearList:sessionStartTimeYearArray
      // })

  };

  renderEligibleClasses() {
    const { classes, dialogData, actionType } = this.props;
    const { formData } = this.state;
    const { eligibleClasses } = formData;
    const disabledEditColumn = () =>{
      return (
       actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL
      );
    };
    // const pastClassesNameSet = new Set(formData.pastClasses.map(({ name }) => ROMAN_CONSTANT_REVERSE[name]));

    const availableClasses = Object.keys(ROMAN_CONSTANT)
     return (
      <>
        {/* {isEligibleClassesVisible() ? ( */}
          <OutLineDiv label="Class">
            {eligibleClasses.map((eligibleClassObj, index: number) => {
              return (
                <>
                  <Grid container justify="space-between" direction="row">
                    <Grid item xs={6} className={classes.mb1x}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={cx(classes.fontSizeMD, classes.labelText)}
                      >
                        Class &nbsp;<span className={classes.error}>*</span>
                      </Typography>
                      <FormControl className={classes.classesDropdown}>
                        <MyPATSelect
                          className={classes.classesList}
                          fullWidthControl
                          name="class"
                          disabled={
                            actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY || disabledEditColumn()
                          }
                          value={
                            formData.eligibleClasses[index]["class"]["name"]
                          }
                          onChange={(event: any) =>
                            this.handleEligibleClassesChange(event, index)
                          }
                          placeHolder={"Class"}

                        >
                          <option value="select Class" className={classes.grey}>
                            Select Class
                          </option>
                          {availableClasses.map((key, index) => (
                            <option key={key} value={key}>
                              {ROMAN_CONSTANT[key]}
                            </option>
                          ))}
                        </MyPATSelect>
                      </FormControl>                      
                    </Grid>
                    {index > 0 ? (
                        <IconButton
                          className={classes.classesCloseButton}
                          onClick={() =>
                            this.handleRemoveEligibleClasses(index)
                          }
                        >
                          <CloseOutlinedIcon
                              />
                        </IconButton>
                      ) : null}
                  </Grid>

                  <Grid container justify="space-between" direction="row">
                    <Grid
                      item
                      xs={6}
                      className={[classes.mb1x, classes.paddingRight].join(" ")}
                    >
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={cx(classes.fontSizeMD, classes.labelText)}
                      >
                        Session Start &nbsp;<span className={classes.error}>*</span>
                      </Typography>
                      <MyPATSelect
                        fullWidthControl
                        name="sessionStartTime"
                        id="sessionStartTime"
                        disabled={
                          !formData.targetYear ||
                          actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY || disabledEditColumn()
                        }
                        value={
                          formData.eligibleClasses[index]["sessionStartTime"] 
                        }
                        onChange={(event: any) =>
                          this.handleEligibleClassesChange(event, index)
                        }
                        error={formData.eligibleClasses[index].error}
                        errorText={formData.eligibleClasses[index].error}
                      >
                        {
                          _.map(
                            this.sessionStartTimeYearList(),
                            (year: any, i: number) => (
                              <option key={i} value={year}>
                                {year}
                              </option>
                            )
                          )
                        
                        }
                      </MyPATSelect>
                    </Grid>

                    <Grid item xs={6} className={[classes.mb1x].join(" ")}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={cx(classes.fontSizeMD, classes.labelText)}
                      >
                        Session End &nbsp;<span className={classes.error}>*</span>
                      </Typography>
                      <MyPATSelect
                        fullWidthControl
                        name="sessionEndTime"
                        id="sessionEndTime"
                        disabled={true}
                        value={
                          formData.eligibleClasses[index]["sessionStartTime"] +
                            1 || null
                        }
                      >
                        <option
                          value={
                            formData.eligibleClasses[index]["sessionEndTime"]
                          }
                        >
                          {formData.eligibleClasses[index]["sessionEndTime"]}
                        </option>
                      </MyPATSelect>
                    </Grid>
                  </Grid>

                  <Grid container justify="flex-end" alignItems="flex-end">
                    {index === eligibleClasses.length - 1  && !disabledEditColumn() ?(
                      <Link
                        align="right"
                        variant="body2"
                        className={classes.addMoreStyle}
                        onClick={this.handleAddEligibleClasses}

                      >
                        Add More
                      </Link>
                    ) : null}
                  </Grid>
                </>
              );
            })}
          </OutLineDiv>
        {/* // ) : null} */}
      </>
    );
  }
  renderAddGoalLevel() {
    const { classes,actionType } = this.props;

    const { formData } = this.state;
    const enabledEditColumn = () =>{
      return (
       actionType === GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL || actionType === GOAL_ACTION_TYPE_CONST.EDIT_GOAL 
      );
    };
    return (
      <div>
        {formData.goalLevels.map((goalLevel, index) => {
          return this.renderIndividualGoalLevel(goalLevel, index);
        })}
        {enabledEditColumn() &&
        <>
        <Grid container justify="flex-end" alignItems="flex-end">
          <Link
            align="right"
            variant="body2"
            className={classes.addMoreStyle}
            onClick={() => this.handleNumberOfGoalLevels("add")}
          >
            Add More
          </Link>
        </Grid>
        </>
        }
      </div>
    );
  }

  renderIndividualGoalLevel(goalLevel: GoalLevel, index: number) {
    const { classes } = this.props;
    const { errForm } = this.state;
    return (
      <div className={classes.closeContainer}>
        <Grid
          container
          justify="space-between"
          direction="row"
          key={index}
          className={[classes.mb1x, classes.paddingLeft].join(" ")}
        >
          <Grid
            item
            xs={6}
            className={[classes.paddingRight].join(" ")}
          >
            <Typography
              variant="body1"
              gutterBottom
              className={cx(classes.fontSizeMD, classes.labelText)}
            >
              Goal Level
              <span className={classes.iconStyle}>
                <CustomInfoIcon
                  infoDialogContentType="Goal Management"
                  isInfoIcon={true}
                  isCenterArrow={true}
                  isRightArrow={false}
                  knowMoreAbout={false}
                  dialogTitle="Goal Level"
                  imageURL="/assets/svg/goalLevelIcon.svg"
                  dialogPara="This feature enables user to define different levels in a Goal. Goal level is defined as a set of measure for differentiating students based on their score."
                  toolTipDirection="top"
                  details="Click to know more"
                />
              </span>
            </Typography>
            <MyPATTextField
              fullWidthControl
              inputId={`goalLevel-${index}`}
              name={`goalLevel-${index}`}
              error={
                !!errForm.goalLevels[index] &&
                errForm.goalLevels[index].name.length > 0
              }
              errorText={
                errForm.goalLevels[index] &&
                errForm.goalLevels[index].name.length > 0
                  ? errForm.goalLevels[index].name[0]
                  : ""
              }
              placeholder="Enter goal level"
              value={goalLevel.name}
              onChange={this.handleGoalLevelChange("name")}
              onFocus={this.goalLevelFocus.bind(this)}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography
              variant="body1"
              gutterBottom
              className={cx(classes.fontSizeMD, classes.labelText)}
            >
              Scale 
            </Typography>
            <MyPATTextField
              fullWidthControl
              inputId={`goalScale-${index}`}
              name={`goalScale-${index}`}
              isCutomMargin={true}
              error={
                !!errForm.goalLevels[index] &&
                errForm.goalLevels[index].scale.length > 0  
              }
              errorText={
                errForm.goalLevels[index] &&
                errForm.goalLevels[index].scale.length > 0
                  ? errForm.goalLevels[index].scale[0]
                  : ""
              }
              placeholder="Enter scale"
              value={goalLevel.scale || ""}
              type="number"
             // disabled={this.handleScaleValue.bind(this)}
              onChange={this.handleGoalLevelChange("scale")}
               onKeyPress={onlyAllowNumbers}
               endAdornment={<div></div>}
               onFocus={this.goalLevelFocus.bind(this)}
            />
          </Grid>

          {index > 0 && (
            <IconButton
              className={classes.closeButton}
              aria-label="remove-goal-field"
              onClick={() => this.handleNumberOfGoalLevels("remove", index)}
            >
              <CloseOutlinedIcon className={classes.fontSizeMD} />
            </IconButton>
          )}
        </Grid>
      </div>
    );
  }
}
const joditButtons = [
  "brush",
  "|",
  "bold",
  "italic",
  "underline",
  "|",
  "font",
  "fontsize",
  "|",
  "ul",
  "ol",
  "|",
  "left",
  "center",
  "right",
  "justify",
];
const mapStateToProps = (state: any) => ({
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
  });

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getGoalList,
      showMsg,
      toggleLicenseExpiredDialog,
      setLoggedInUser,
      showLoader: () => dispatch({ type: "SHOW_LOADER" }),
      hideLoader: () => dispatch({ type: "HIDE_LOADER" }),
    },
    dispatch
  );


export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(AddGoalDialog));